<template>
	<div>
		<div class="content">
			<!-- 班组隐患数量统计 -->
			<ul id="teamHiddenTroubleNumTotal">
				<li class="item item1">
					<div class="title">
						<!-- <div class="circle"></div> -->
						<div class="name">{{dataList[0]?dataList[0].dept_name:'暂无数据'}}</div>
					</div>
					<div class="num">隐患数量：{{dataList[0]?dataList[0].total : 0}}</div>
				</li>
				<li class="item item2">
					<div class="title">
						<!-- <div class="circle"></div> -->
						<div class="name">{{dataList[1]?dataList[1].dept_name:'暂无数据'}}</div>
					</div>
					<div class="num">隐患数量：{{dataList[1]?dataList[1].total : 0}}</div>
				</li>
				<li class="item item3">
					<div class="title">
						<!-- <div class="circle"></div> -->
						<div class="name">{{dataList[2]?dataList[2].dept_name:'暂无数据'}}</div>
					</div>
					<div class="num">隐患数量：{{dataList[2]?dataList[2].total : 0}}</div>
				</li>
				<li class="item item4">
					<div class="title">
						<!-- <div class="circle"></div> -->
						<div class="name">{{dataList[3]?dataList[3].dept_name:'暂无数据'}}</div>
					</div>
					<div class="num">隐患数量：{{dataList[3]?dataList[3].total : 0}}</div>
				</li>
				<li class="item item5">
					<div class="title">
						<!-- <div class="circle"></div> -->
						<div class="name">{{dataList[4]?dataList[4].dept_name:'暂无数据'}}</div>
					</div>
					<div class="num">隐患数量：{{dataList[4]?dataList[4].total : 0}}</div>
				</li>
				<li class="item item6">
					<div class="title">
						<!-- <div class="circle"></div> -->
						<div class="name">{{dataList[5]?dataList[5].dept_name:'暂无数据'}}</div>
					</div>
					<div class="num">隐患数量：{{dataList[5]?dataList[5].total : 0}}</div>
				</li>
				<li class="item item7">
					<div class="title">
						<!-- <div class="circle"></div> -->
						<div class="name">{{dataList[6]?dataList[6].dept_name:'暂无数据'}}</div>
					</div>
					<div class="num">隐患数量：{{dataList[6]?dataList[6].total : 0}}</div>
				</li>
				<li class="item item8">
					<div class="title">
						<!-- <div class="circle"></div> -->
						<div class="name">{{dataList[7]?dataList[7].dept_name:'暂无数据'}}</div>
					</div>
					<div class="num">隐患数量：{{dataList[7]?dataList[7].total : 0}}</div>
				</li>
				<li class="item item9">
					<div class="title">
						<!-- <div class="circle"></div> -->
						<div class="name">{{dataList[8]?dataList[8].dept_name:'暂无数据'}}</div>
					</div>
					<div class="num">隐患数量：{{dataList[8]?dataList[8].total : 0}}</div>
				</li>
				<li class="item item10">
					<div class="title">
						<!-- <div class="circle"></div> -->
						<div class="name">{{dataList[9]?dataList[9].dept_name:'暂无数据'}}</div>
					</div>
					<div class="num">隐患数量：{{dataList[9]?dataList[9].total : 0}}</div>
				</li>
			</ul>
			<!-- 班组隐患数量统计 -->
		</div>
	</div>
</template>
<script>
	import {
		apiurl,
		imgurl
	} from '../../common/js/baseApi.js'
	import axios from 'axios'
	export default {
		components: {},
		data() {
			return {
				pId: '', // 用户id
				dataList: []
			}
		},
		computed: {},
		watch: {},
		methods: {
			getTotalByDeptTrouble() {
				axios.get(apiurl + '/index/totalByDeptTrouble', {
						params: {
							pId: this.pId
						}
					})
					.then(data => {
						if (data.data.status !== 1) {
							return
						}
						this.dataList = data.data.data
					})
					.catch(err => {

					})
			}
		},
		created() {},
		mounted() {
			var url = window.location.search
			var theRequest = new Object()
			if (url.indexOf('?') != -1) {
				var str = url.split('?')[1]
				var strs = str.split('&')
				for (var i = 0; i < strs.length; i++) {
					theRequest[strs[i].split('=')[0]] = (strs[i].split('=')[1])
				}
			}
			this.pId = theRequest.pId
			this.getTotalByDeptTrouble()
		},
		beforeCreate() {},
		beforeMount() {},
		beforeUpdate() {},
		updated() {},
		beforeDestroy() {},
		destroyed() {},
		activated() {},
	}
</script>
<style lang='scss' scoped>
	.content {
		width: 50.5625rem;
		height: 25rem;

		/* 班组隐患数量统计 */
		#teamHiddenTroubleNumTotal {
			position: relative;
			width: 100%;
			height: 100%;

			.item {
				/* width: 9.75rem; */
				height: 13.125rem;
				background: url(../../common/img/centerCenter/card.png) 0 0 no-repeat;
				background-size: 100% 100%;
				padding: 1.5625rem 1.5rem 9.375rem;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				justify-content: space-between;
				flex-direction: column;

				.title {
					width: 100%;
					height: 0.975rem;
					display: flex;
					align-items: center;
					justify-content: center;

					.circle {
						width: 0.125rem;
						height: 0.125rem;
						border: 0.125rem solid #FFFFFF;
						border-radius: 50%;
						margin-right: 0.25rem;
					}

					.name {
						font-size: 0.875rem;
						color: #FFFFFF;
					}
				}

				.num {
					width: 100%;
					height: 1.0625rem;
					border: 1px solid #4E5C8D;
					line-height: 1.0625rem;
					font-size: 0.75rem;
					color: #FFFFFF;
					text-align: center;
				}
			}

			.item:hover {
				background: url(../../common/img/centerCenter/cardActive.png) 0 0 no-repeat;
				background-size: 100% 100%;

				.title {
					opacity: 0.7;
				}

				.num {
					opacity: 0.5;
				}
			}

			.item1 {
				position: absolute;
				left: 20rem;
				top: 0;
			}

			.item2 {
				position: absolute;
				left: 8.1875rem;
				top: 2.3125rem;
			}

			.item3 {
				position: absolute;
				right: 9.1875rem;
				top: 1.25rem;
			}

			.item4 {
				position: absolute;
				left: 14.125rem;
				top: 7.8125rem;
			}

			.item5 {
				position: absolute;
				right: 15.0625rem;
				top: 6.5625rem;
			}

			.item6 {
				position: absolute;
				left: 3.3125rem;
				top: 7.8125rem;
			}

			.item7 {
				position: absolute;
				right: -1.375rem;
				top: 5rem;
			}

			.item8 {
				position: absolute;
				right: 4.5625rem;
				top: 9.6875rem;
			}

			.item9 {
				position: absolute;
				left: -1.5625rem;
				top: 13.25rem;
			}

			.item10 {
				position: absolute;
				right: -1.5625rem;
				top: 14.3125rem;
			}
		}

		/* 班组隐患数量统计 */
	}
</style>



// WEBPACK FOOTER //
// src/components/centerCenter/index.vue